<template>
  <div>
    <v-toolbar
      flat
      class="elevation-1"
    >
      <v-toolbar-title>{{ titulo }}</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn
        v-if="puedo('alta')"
        class="white--text"
        round
        color="primary"
        @click="crear"
      >
        <v-icon
          dark
          small
          class="mr-2"
        >add</v-icon>
        Nuevo
      </v-btn>
      <v-btn
        flat
        icon
        small
        @click="mostrarFiltros()"
      >
        <v-icon class="primary--text">filter_list</v-icon>
      </v-btn>
    </v-toolbar>
    <filtros
      v-bind:filtros="filtros"
      v-bind:referencia="referenciaFiltros"
      v-bind:combos="combos"
      v-on:alFiltrar="alFiltrar"
    ></filtros>
    <v-data-table
      must-sort
      :headers="headers"
      :items="items"
      :pagination.sync="paginacion"
      :total-items="totalItems"
      :rows-per-page-items="itemsPorPagina"
      :loading="cargando"
      class="elevation-1"
    >
      <v-progress-linear
        v-slot:progress
        color="blue"
        indeterminate
        v-if="cargando"
      ></v-progress-linear>
      <template v-slot:items="props">
        <td class="text-xs-left pa1">{{ props.item.id }}</td>
        <td class="text-xs-left pa1">{{ props.item.estado.nombre }}</td>

        <td class="text-xs-left pa1">{{ props.item.fecha | formatoFecha }}</td>
        <td class="text-xs-left pa1">{{ props.item.fecha_cierre | formatoFecha }}</td>

        <td class="text-xs-left pa1">{{ props.item.emitido_obra_social.nombre }}</td>
        <td class="text-xs-left pa1">{{ props.item.concepto }}</td>

        <td class="text-xs-right pa1">{{ props.item.importe | currency }}</td>
        <td class="justify-end layout">
          <v-tooltip
            bottom
            v-if="props.item.pagos.length < 1"
          >
            <template v-slot:activator="{ on }">
              <v-icon
                small
                color="red"
                dark
                v-on="on"
              >payment</v-icon>
            </template>
            <span>Sin medios de pago</span>
          </v-tooltip>

          <v-btn
            icon
            flat
            small
            color="blue-grey"
            class="mx-1"
            @click="accionEnItem(props.item, 'verDetalle')"
          >
            <v-icon small>list</v-icon>
          </v-btn>

          <v-menu
            bottom
            left
            fixed
            v-if="armarMenuAcciones(props.item).length > 0"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                flat
                icon
                small
                color="blue-grey"
                v-on="on"
              >
                <v-icon>more_vert</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-tile
                v-for="(accion, key) in armarMenuAcciones(props.item)"
                :key="key"
                @click="accionEnItem(props.item, accion.key)"
              >
                <v-list-tile-action style="min-width:30px;">
                  <v-icon small>{{ accion.icono }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>{{ accion.titulo }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </td>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import EventBus from '@/helpers/eventBus'
import filtros from './ReciboListadoFiltros'
import abmListadoMixin from '@/mixins/abmListado'
import { nombreCentro, cabeceraComprobante } from '@/helpers/filtros'
export default {
  name: 'ReciboListado',
  mixins: [abmListadoMixin],
  components: {
    filtros
  },
  filters: {
    nombreCentro,
    cabeceraComprobante
  },
  props: {
    combos: {
      type: Object,
      required: true
    }
  },
  computed: {
    referenciaFiltros () {
      return this.referencia
    }
  },
  data: () => ({
    titulo: 'Recibos',
    headers: [
      { text: 'Nro', value: 'id', sortable: true },
      { text: 'Estado', value: 'estado_id', sortable: false },
      { text: 'Fecha Emisión', value: 'fecha', sortable: false },
      { text: 'Fecha Cierre', value: 'fecha_cierre', sortable: false },
      { text: 'A la orden de', value: 'emitido_por_obra_social_id', sortable: false },
      { text: 'Concepto', value: 'concepto', sortable: false },
      { text: 'Importe', value: 'importe', sortable: false, align: 'right' },
      { text: 'Acciones', value: 'id', sortable: false, align: 'center' }
    ],
    paginacion: { descending: true, sortBy: 'id' }
  }),
  mounted () { },
  methods: {
    metodoFiltrar (filtros) {
      let vm = this
      return vm.modeloApi.filtrar(filtros)
    },

    accionEnItem (item, accion) {
      switch (accion) {
        case 'borrar':
          this.eliminar(item)
          break

        case 'verDetalle':
        case 'verPagos':
        case 'imprimir':
          this.$emit(accion, item)
          break
        case 'auditoria':
          EventBus.$emit(accion + ':mostrar', item)
          break
      }
    },
    armarMenuAcciones (item) {
      let acciones = []
      switch (item.estado.codigo) {
        case 'cerrado':
          if (this.puedo('baja') && !item.tiene_proyecto_pago) {
            acciones.push({ key: 'borrar', icono: 'delete', titulo: 'Borrar' })
          }
          if (this.puedo('lectura') || this.puedo('modif')) {
            acciones.push({ key: 'verPagos', icono: 'payment', titulo: 'Medios de Pago' })
          }
          if (this.puedo('lectura')) {
            acciones.push({ key: 'imprimir', icono: 'print', titulo: 'Imprimir' })
          }
          break
      }
      acciones.push({
        key: 'auditoria',
        icono: 'verified_user',
        titulo: 'Auditoría'
      })
      return acciones
    },
    mostrarFiltros () {
      EventBus.$emit(this.referenciaFiltros + ':abrir')
    },
    alFiltrar (filtros) {
      this.filtros = filtros
      this.filtrar()
    }
  }
}
</script>

<style lang="scss" scoped></style>
